const storageKey = 'dearore-wishlist-v1';

function getWishlist() {
  try { return new Set(JSON.parse(window.localStorage.getItem(storageKey) || '[]')); } catch { return new Set(); }
}

function saveWishlist(items) { window.localStorage.setItem(storageKey, JSON.stringify([...items])); }

function syncFavorites() {
  const wishlist = getWishlist();
  document.querySelectorAll('[data-dearore-favorite]').forEach((button) => {
    const saved = wishlist.has(button.dataset.productId);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? '取消收藏' : '加入收藏'} ${button.dataset.productTitle || ''}`.trim());
  });
}

function startCountdowns() {
  document.querySelectorAll('[data-dearore-sale-end]').forEach((bar) => {
    if (bar.dataset.dearoreCountdownReady === 'true') return;
    bar.dataset.dearoreCountdownReady = 'true';
    const start = Date.parse(bar.dataset.dearoreSaleStart || '');
    const end = Date.parse(bar.dataset.dearoreSaleEnd || '');
    const output = bar.querySelector('[data-dearore-countdown]');
    const label = bar.querySelector('[data-dearore-sale-label]');
    const showCountdown = bar.dataset.dearoreShowCountdown === 'true';
    const tick = () => {
      const now = Date.now();
      let target = end;

      if (!Number.isNaN(start) && now < start) {
        target = start;
        if (label) label.textContent = bar.dataset.dearoreUpcomingLabel || '優惠即將開始';
      } else if (!Number.isNaN(end) && now >= end) {
        if (bar.dataset.dearoreHideEnded === 'true') {
          bar.hidden = true;
          return;
        }
        if (label) label.textContent = bar.dataset.dearoreEndedLabel || '優惠已結束';
        if (output) output.textContent = '';
        return;
      } else if (label) {
        label.textContent = bar.dataset.dearoreActiveLabel || '';
      }

      if (!showCountdown || !output || Number.isNaN(target)) {
        if (output) output.hidden = true;
        return;
      }
      output.hidden = false;
      const seconds = Math.max(0, Math.floor((target - now) / 1000));
      const days = Math.floor(seconds / 86400);
      const hours = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      const remaining = String(seconds % 60).padStart(2, '0');
      output.textContent = `${days}D ${hours}H ${minutes}M ${remaining}S`;
    };
    tick();
    window.setInterval(tick, 1000);
  });
}

function attachHoverLenses() {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  document.querySelectorAll('media-gallery[data-dearore-hover-lens="true"]').forEach((gallery) => {
    if (gallery.dataset.dearoreLensReady === 'true') return;
    gallery.dataset.dearoreLensReady = 'true';
    const size = Number(gallery.dataset.dearoreLensSize) || 180;
    const zoom = Number(gallery.dataset.dearoreLensZoom) || 2.5;

    gallery.querySelectorAll('.product-media-container--image').forEach((container) => {
      if (container.closest('.dialog-zoomed-gallery')) return;
      const image = container.querySelector('.product-media__image');
      if (!image) return;
      const lens = document.createElement('span');
      lens.className = 'dearore-hover-lens';
      lens.setAttribute('aria-hidden', 'true');
      lens.style.setProperty('--dearore-lens-size', `${size}px`);
      container.appendChild(lens);

      const update = (event) => {
        const rect = image.getBoundingClientRect();
        const x = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
        const y = Math.max(0, Math.min(event.clientY - rect.top, rect.height));
        const highRes = image.dataset.maxResolution || image.currentSrc || image.src;
        lens.style.backgroundImage = `url("${highRes.replace(/"/g, '%22')}")`;
        lens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
        lens.style.backgroundPosition = `${(x / rect.width) * 100}% ${(y / rect.height) * 100}%`;
        lens.style.left = `${event.clientX - container.getBoundingClientRect().left}px`;
        lens.style.top = `${event.clientY - container.getBoundingClientRect().top}px`;
      };

      container.addEventListener('pointerenter', (event) => {
        lens.dataset.visible = 'true';
        update(event);
      });
      container.addEventListener('pointermove', update);
      container.addEventListener('pointerleave', () => { lens.dataset.visible = 'false'; });
    });
  });
}

function attachVideoPreviews() {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  document.querySelectorAll('[data-dearore-video-card], .card-gallery').forEach((card) => {
    const video = card.querySelector('video');
    if (!video) return;
    card.addEventListener('pointerenter', () => video.play().catch(() => undefined));
    card.addEventListener('pointerleave', () => { video.pause(); video.currentTime = 0; });
  });
}

function initializeDearOre() { syncFavorites(); startCountdowns(); attachVideoPreviews(); attachHoverLenses(); }

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-dearore-favorite]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const wishlist = getWishlist();
  wishlist.has(button.dataset.productId) ? wishlist.delete(button.dataset.productId) : wishlist.add(button.dataset.productId);
  saveWishlist(wishlist);
  syncFavorites();
});
document.addEventListener('DOMContentLoaded', initializeDearOre);
document.addEventListener('shopify:section:load', initializeDearOre);
